// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rx0wN","buttons":"styles_buttons__dIPuz"};